import { AnalyticsEvent } from "../store/base-store.abstract";
import { ManageCommon } from "./base-manager.abstract";

export abstract class ParselyManage extends ManageCommon {
  protected parselyLibId = "parsely-cfg";
  abstract trackAction(event: AnalyticsEvent): void;
}
